import { type ICycleResetPeriod, type IState } from "./helpers";

export const recordCycleResetPeriod = (state: IState, eligibleForResetDate: Date) => {
    if (state.customCodes.disableCycleResetPeriod) {
        return;
    }
    if (!state.cycle.hasStarted) {
        return;
    }

    state.cycle.cycleResetPeriod = {
        fromDate: getCurrentRestStartDate(state),
        eligibleForResetDate
    };
};

export const getDateRestBecameLongEnough = (state: IState, cycleRestartMinimum: number) =>
    new Date(getCurrentRestStartDate(state).getTime() + cycleRestartMinimum);

export const closeCycleResetPeriodOnReturnToDuty = (state: IState) => {
    const cycleResetPeriodAwaitingReturnToDuty = findCycleResetPeriodAwaitingReturnToDuty(state);
    if (!cycleResetPeriodAwaitingReturnToDuty) {
        return;
    }

    cycleResetPeriodAwaitingReturnToDuty.toDate = new Date(state.currentDate.getTime());
};

const getCurrentRestStartDate = (state: IState) => new Date(state.nextDate.getTime() - state.cycle.cycleConsecutiveOffCount);

const findCycleResetPeriodAwaitingReturnToDuty = (state: IState) => {
    for (let index = state.cycles.length - 1; index >= 0; index--) {
        const cycleResetPeriod = state.cycles[index].cycleResetPeriod;
        if (cycleResetPeriod) {
            return isAwaitingReturnToDuty(cycleResetPeriod) ? cycleResetPeriod : undefined;
        }
    }

    return undefined;
};

const isAwaitingReturnToDuty = (cycleResetPeriod: ICycleResetPeriod) => cycleResetPeriod.toDate === undefined;
